<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        title
        @back="$router.push('/home').catch(() => {})"
        :content="$t('cockpit-prepostagem')"
      ></el-page-header>
    </el-card>
    <br />
    <el-card>
      <el-card shadow="hover">
        <el-form :model="ruleForm" inline="true" :rules="rules" ref="ruleForm">
          <el-form-item :label="$t('periodo')" prop="name">
            <el-date-picker
              v-model="ruleForm.start"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="à"
              format="dd/MM/yyyy"
              start-placeholder="Inicio"
              end-placeholder="Fim"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('filial')" prop="branch">
            <el-select v-model="value" placeholder="Select">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('servico')" prop="name">
            <el-select v-model="value" placeholder="Select">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-drawer title="Filtro" :visible.sync="drawer" size="50%">
            <div>
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="20%"
                size="mini"
              >
                <el-row gutter="5">
                  <el-col :xs="24" :lg="24">
                    <el-radio-group v-model="radio">
                      <el-radio label="3" class="uppercase">{{
                        $t("conferido")
                      }}</el-radio>
                      <el-radio label="6" class="uppercase">{{
                        $t("plp")
                      }}</el-radio>
                      <el-radio label="9" class="uppercase">{{
                        $t("pre-postagem")
                      }}</el-radio>
                      <el-radio label="12" class="uppercase">{{
                        $t("data-pre-postagem")
                      }}</el-radio>
                    </el-radio-group>
                  </el-col>
                </el-row>
                <el-row gutter="5">
                  <el-col :xs="12" :lg="12">
                    <el-form-item :label="$t('periodo')" prop="code">
                      <el-date-picker
                        v-model="value1"
                        type="date"
                        placeholder="Inicial"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="10" :lg="10">
                    <el-form-item :label="$t('ate')" prop="code">
                      <el-date-picker
                        v-model="value1"
                        type="date"
                        placeholder="Inicial"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row gutter="5">
                  <el-col :xs="12" :lg="12">
                    <el-form-item :label="$t('objeto')" prop="code">
                      <el-input ref="name" v-model="ruleForm.name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="10" :lg="10">
                    <el-form-item :label="$t('nota')" prop="code">
                      <el-input ref="name" v-model="ruleForm.name"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row gutter="5">
                  <el-col :xs="12" :lg="12">
                    <el-form-item
                      class="uppercase"
                      :label="$t('plp')"
                      prop="code"
                    >
                      <el-input ref="name" v-model="ruleForm.name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="10" :lg="10">
                    <el-form-item
                      class="uppercase"
                      :label="$t('os')"
                      prop="code"
                    >
                      <el-input ref="name" v-model="ruleForm.name"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row gutter="5">
                  <el-col :xs="12" :lg="12">
                    <el-form-item :label="$t('servico')" prop="code">
                      <el-select placeholder="Selecione  uma opção">
                        <el-option></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="10" :lg="10">
                    <el-form-item :label="$t('coleta')" prop="code">
                      <el-select placeholder="Selecione uma opção">
                        <el-option></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row gutter="5">
                  <el-col :xs="12" :lg="12">
                    <el-form-item :label="$t('contrato')" prop="code">
                      <el-input ref="name" v-model="ruleForm.name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="10" :lg="10">
                    <el-form-item :label="$t('status')" prop="code">
                      <el-select placeholder="Selecione uma opção">
                        <el-option></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row gutter="5">
                  <el-col :xs="12" :lg="12">
                    <el-form-item :label="$t('conferido')" prop="code">
                      <el-select placeholder="Selecione uma opção">
                        <el-option></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="10" :lg="10">
                    <el-form-item
                      :label="$t('svp')"
                      class="uppercase"
                      style="text-transform: uppercase"
                      prop="code"
                    >
                      <el-select placeholder="Selecione uma opção">
                        <el-option></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row gutter="5">
                  <el-col :xs="12" :lg="12">
                    <el-form-item :label="$t('plp')" prop="code">
                      <el-select placeholder="Selecione um cliente">
                        <el-option></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="10" :lg="10">
                    <el-form-item :label="$t('sro-objetos')" prop="code">
                      <el-select placeholder="Selecione um cliente">
                        <el-option></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <div style="text-align: center">
                <el-button type="primary" @click="innerDrawer = true"
                  >Filtrar</el-button
                >
              </div>
            </div>
          </el-drawer>

          <el-button style="float: right" @click="drawer = true">{{
            $t("mais-filtros")
          }}</el-button>
        </el-form>
      </el-card>
      <br />
      <el-row gutter="5">
        <el-col :lg="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>{{ $t("postagens") }}</span>
              <el-form
                style="float: right; padding: 3px 0"
                :model="ruleForm"
                inline="true"
                :rules="rules"
                ref="ruleForm"
              >
                <el-form-item :label="$t('paginacao')" prop="name">
                  <el-select v-model="value" placeholder="Select">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <el-table
              :data="tablePost"
              stripe
              style="width: 100%"
              :default-sort="{ prop: 'name', order: 'ascending' }"
            >
              <el-table-column sortable prop="customer" :label="$t('filial')">
                <template slot-scope="scope">
                  <el-button type="text">{{ scope.row.customer }}</el-button>
                </template>
              </el-table-column>
              <el-table-column sortable prop="object" :label="$t('objeto')">
                <template slot-scope="scope">
                  <el-button type="text">{{ scope.row.object }}</el-button>
                </template>
              </el-table-column>
              <el-table-column
                prop="previous"
                :label="$t('previsao')"
              ></el-table-column>
              <el-table-column
                prop="deadline"
                :label="$t('prazo')"
              ></el-table-column>
              <el-table-column
                prop="services"
                :label="$t('servico')"
              ></el-table-column>
              <el-table-column
                prop="zicode"
                :label="$t('cep')"
              ></el-table-column>
              <el-table-column label="#" width="120">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    icon="el-icon-edit"
                    @click="editar(scope.row.id)"
                    circle
                  ></el-button>
                  <el-button
                    type="danger"
                    icon="el-icon-delete"
                    @click="remove(scope.row.id, scope.row.name)"
                    circle
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="bottom clearfix">
              <el-row gutter="5">
                <el-col :lg="10">
                  <el-pagination
                    layout="prev, pager, next"
                    :total="1000"
                  ></el-pagination>
                </el-col>
                <el-col :lg="3" style="margin-top: 2px; float: right">
                  <el-dropdown>
                    <el-button>
                      Exportar
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>XLS</el-dropdown-item>
                      <el-dropdown-item>PDF</el-dropdown-item>
                      <el-dropdown-item>HTML</el-dropdown-item>
                      <el-dropdown-item>CSV</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-col>
        <el-col :lg="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>{{ $t("relacao-atrasos") }}</span>
            </div>
            <el-table
              :data="
                tableData.filter(
                  (data) =>
                    !filter ||
                    data.name.toLowerCase().includes(filter.toLowerCase()) ||
                    data.companyname
                      .toLowerCase()
                      .includes(filter.toLowerCase()) ||
                    data.federalid.toLowerCase().includes(filter.toLowerCase())
                )
              "
              stripe
              style="width: 100%"
              :default-sort="{ prop: 'name', order: 'ascending' }"
            >
              <el-table-column
                sortable
                prop="package"
                :label="$t('objeto')"
              ></el-table-column>
              <el-table-column
                sortable
                prop="service"
                :label="$t('dias')"
              ></el-table-column>
              <el-table-column
                sortable
                prop="package"
                :label="$t('postagem')"
              ></el-table-column>
              <el-table-column
                sortable
                prop="package"
                :label="$t('previsao')"
              ></el-table-column>
            </el-table>
            <div class="bottom clearfix">
              <el-row gutter="5">
                <el-col :lg="10">
                  <el-pagination
                    layout="prev, pager, next"
                    :total="1000"
                  ></el-pagination>
                </el-col>
                <el-col :lg="3" style="margin-top: 2px; float: right">
                  <el-dropdown>
                    <el-button>
                      Exportar
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>XLS</el-dropdown-item>
                      <el-dropdown-item>PDF</el-dropdown-item>
                      <el-dropdown-item>HTML</el-dropdown-item>
                      <el-dropdown-item>CSV</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row gutter="5">
        <el-col :lg="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>{{ $t("ordem-servico") }}</span>
            </div>
            <el-table
              :data="
                tableData.filter(
                  (data) =>
                    !filter ||
                    data.name.toLowerCase().includes(filter.toLowerCase()) ||
                    data.companyname
                      .toLowerCase()
                      .includes(filter.toLowerCase()) ||
                    data.federalid.toLowerCase().includes(filter.toLowerCase())
                )
              "
              stripe
              style="width: 100%"
              :default-sort="{ prop: 'name', order: 'ascending' }"
            >
              <el-table-column sortable prop="package" :label="$t('os')">
                <template slot-scope="scope">
                  <el-button type="text">{{ scope.row.id }}</el-button>
                </template>
              </el-table-column>
              <el-table-column
                sortable
                prop="package"
                :label="$t('filial')"
              ></el-table-column>
              <el-table-column
                prop="services"
                :label="$t('data')"
              ></el-table-column>
              <el-table-column label="#" width="180">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    icon="el-icon-edit"
                    @click="editar(scope.row.id)"
                    circle
                  ></el-button>
                  <el-button
                    type="danger"
                    icon="el-icon-delete"
                    @click="remove(scope.row.id, scope.row.name)"
                    circle
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="bottom clearfix">
              <el-row gutter="5">
                <el-col :lg="10">
                  <el-pagination
                    layout="prev, pager, next"
                    :total="1000"
                  ></el-pagination>
                </el-col>
                <el-col :lg="6" style="margin-top: 2px; float: right">
                  <el-button>
                    <i class="el-icon-plus"></i>
                    Nova
                  </el-button>
                  <el-dropdown>
                    <el-button>
                      Exportar
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>XLS</el-dropdown-item>
                      <el-dropdown-item>PDF</el-dropdown-item>
                      <el-dropdown-item>HTML</el-dropdown-item>
                      <el-dropdown-item>CSV</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
//import { UserService } from "@/services/users/user.services";
import { i18n } from "@/plugin/i18n";

export default {
  name: "CockpitPrepost",
  methods: {
    fetchRecords() {
      /*    const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      UserService.list()
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());*/
    },
  },
  mounted() {
    const vm = this;
    vm.fetchRecords();
  },
  data() {
    return {
      filter: "",
      drawer: false,
      innerDrawer: false,
      tableData: [],
      tablePost: [
        {
          customer: "Cliente 1",
          object: "OB00121210PR",
          send: "10/08/2020",
          previous: "15/08/2020",
          deadline: "18/08/2020",
          services: "0001-SEDEX",
          zicode: "00000-000",
        },
      ],
      ruleForm: {
        start: "",
      },
    };
  },
};
</script>
<style>
.right {
  float: right;
}
.label {
  font-weight: bold;
}
</style>